import { emptyReferenceMapCoreCfn } from '.';
import { ReferenceMap } from '../../shared.types';

export const emptyReferenceMapCfn = (): ReferenceMap => {
	return {
		id: null,
		...emptyReferenceMapCoreCfn()
	};
};
